import { defineMessages } from 'react-intl';

export default defineMessages({
    claimInformation: {
        id: 'portal.fnol.common.views.fnol.Claim Information',
        defaultMessage: 'Claim Information'
    },
    selectPolcicy: {
        id: 'portal.fnol.wizard.steps.Select Policy',
        defaultMessage: 'Select Policy'
    },
    additionalInformation: {
        id: 'portal.fnol.wizard.steps.Additional Information',
        defaultMessage: 'Additional Information'
    },
    searchCriteria: {
        id: 'portal.fnol.common.views.policy-select-policyholder.No policies were found that match the search criteria.',
        defaultMessage: 'No policies were found that match the search criteria.',
    },
    selectPolicySubheading: {
        id:'portal.fnol.common.views.policy-select-policyholder.To expedite your experience, complete an',
        defaultMessage:'To expedite your experience, complete an {employersReport} (select Resource: Claims Kit for your state) prior to this online submission. This system will not produce a completed Employer\'s Report of Injury for submission to the state.'
    },
    selectPolicy: {
        id: 'portal.fnol.common.views.policy-select-policyholder.Select A Policy',
        defaultMessage: 'Select A Policy',
    },
    lossInformation: {
        id: 'portal.fnol.common.views.policy-select-policyholder.Loss Information',
        defaultMessage: 'Loss Information {policyNumber}'
    },
    searchingPolicies: {
        id: 'portal.fnol.common.views.policy-select-policyholder.Searching for your policies...',
        defaultMessage: 'Searching for your policies...'
    },
    policyNotFoundMessage: {
        id: 'portal.fnol.common.views.policy-select-producer.No policies were found that match the search criteria.',
        defaultMessage: 'No policies were found that match the search criteria.'
    },
    whenLossOccur: {
        id: 'portal.fnol.common.directives.loss-date-input.When did loss occur?',
        defaultMessage: 'When did loss occur?'
    },
    fnolSummaryHeader: {
        id: 'portal.fnol.wizard.step.Summary',
        defaultMessage: 'Summary'
    },
    fnolReviewInformation: {
        id: 'portal.fnol.common.views.summary.Please review the following information before submitting:',
        defaultMessage: 'Please review the following information before submitting:'
    },
    fnolPolicyNumber: {
        id: 'portal.fnol.common.views.summary.Policy Number',
        defaultMessage: 'Policy Number'
    },
    fnolTypeOfIncident: {
        id: 'portal.fnol.common.views.summary.Type of Incident',
        defaultMessage: 'Type of Incident'
    },
    fnolSummaryWhen: {
        id: 'portal.fnol.common.views.summary.When?',
        defaultMessage: 'When?'
    },
    fnolSummaryWhere: {
        id: 'portal.fnol.common.views.summary.Where?',
        defaultMessage: 'Where?'
    },
    fnolSummaryContactPerson: {
        id: 'portal.fnol.common.views.summary.Contact Person',
        defaultMessage: 'Contact Person'
    },
    fnolRepairFacility: {
        id: 'portal.fnol.common.views.summary.Repair Facility',
        defaultMessage: 'Repair Facility'
    },
    fnolNoRepairRequested: {
        id: 'portal.fnol.common.views.summary.No repair requested',
        defaultMessage: 'No repair requested'
    },
    fnolNoteToAdjuter: {
        id: 'portal.fnol.common.views.summary.Note to Adjuster',
        defaultMessage: 'Note to Adjuster'
    },
    fnolEdit: {
        id: 'portal.fnol.common.views.summary.Edit',
        defaultMessage: 'Edit'
    },
    fnolDelete: {
        id: 'portal.fnol.common.views.summary.Delete',
        defaultMessage: 'Delete'
    },
    fnolAddNoteToAdjuster: {
        id: 'portal.fnol.common.views.summary.Add a Note to the Adjuster',
        defaultMessage: 'Add a Note to the Adjuster'
    },
    fnolSummaryPara: {
        id: 'portal.fnol.common.views.summary.This represents where a carrier might put the text surrounding their Fraud statement. This text is illustrative and should be updated accordingly.',
        defaultMessage: 'This represents where a carrier might put the text surrounding their Fraud statement. This text is illustrative and should be updated accordingly.'
    },
    dialogAddNoteToAdjuster: {
        id: 'portal.fnol.common.views.note-dialog.Add a Note to the Adjuster',
        defaultMessage: 'Add a Note to the Adjuster'
    },
    dialogSubject: {
        id: 'portal.fnol.common.views.note-dialog.Subject',
        defaultMessage: 'Subject'
    },
    dialogNote: {
        id: 'portal.fnol.common.views.note-dialog.Note',
        defaultMessage: 'Note'
    },
    dialogCancel: {
        id: 'portal.fnol.common.views.note-dialog.Cancel',
        defaultMessage: 'Cancel'
    },
    dialogOk: {
        id: 'portal.fnol.common.views.note-dialog.OK',
        defaultMessage: 'Ok'
    },
    primaryContactDetails: {
        id: 'portal.fnol.common.views.main-contact.Primary Contact Details',
        defaultMessage: 'Primary Contact Details'
    },
    verifyContactInformation: {
        id: 'portal.fnol.common.views.main-contact.Verify the contact information with the client. They may have changed address recently or would prefer to use another address for claim correspondence.',
        defaultMessage: 'Verify the contact information with the client. They may have changed address recently or would prefer to use another address for claim correspondence.'
    },
    contactDetailsWizardStep: {
        id: 'portal.fnol.wizard.step.Contact Details',
        defaultMessage: 'Contact Details'
    },
    commonContactHeader: {
        id: 'portal.fnol.common.views.main-contact.Contact',
        defaultMessage: 'Contact'
    },
    commonContactEmailHeader: {
        id: 'portal.fnol.common.views.main-contact.Email',
        defaultMessage: 'Email'
    },
    wizardTitleAdditionalInformation: {
        id: 'portal.fnol.wizard.step.Additional Information',
        defaultMessage: 'Additional Information'
    },
    fnolSupportingInformation: {
        id: 'portal.fnol.common.views.more-info.Supporting Information',
        defaultMessage: 'Supporting Information'
    },
    fnolAddMoreInfo: {
        id: 'portal.fnol.common.views.more-info.Add photos or documents that are relevant to the incident and may help with the claim.',
        defaultMessage: 'Add photos or documents that are relevant to the incident and may help with the claim.'
    },
    fnolWitnessesOtherParties: {
        id: 'portal.fnol.common.views.more-info.Witnesses or Other Parties',
        defaultMessage: 'Witnesses or Other Parties'
    },
    fnolAddPerson: {
        id: 'portal.fnol.common.views.more-info.Add Party',
        defaultMessage: 'Add Party'
    },
    fnolAnotherPerson: {
        id: 'portal.fnol.common.views.more-info.Another person',
        defaultMessage: 'Another person'
    },
    fnolFirstName: {
        id: 'portal.fnol.common.views.more-info.First name',
        defaultMessage: 'First Name'
    },
    fnolLastName: {
        id: 'portal.fnol.common.views.more-info.Last name',
        defaultMessage: 'Last Name'
    },
    fnolInvolvement: {
        id: 'portal.fnol.common.views.more-info.Involvement',
        defaultMessage: 'Involvement'
    },
    fnolPhoneNumber: {
        id: 'portal.fnol.common.views.more-info.Phone number',
        defaultMessage: 'Phone number'
    },
    fnolInjured: {
        id: 'portal.fnol.common.views.more-info.Injured',
        defaultMessage: 'Injured'
    },
    fnolRemoveUploadedDocument: {
        id: 'portal.platform.widgets.fileupload.templates.Are you sure you want to remove:',
        defaultMessage: 'Are you sure you want to remove: {documentName}?'
    },
    fnolRemove: {
        id: 'portal.fnol.common.views.more-info.Remove',
        defaultMessage: 'Remove'
    },
    fnolYes: {
        id: 'portal.fnol.common.controllers.MoreInfoCtrl.Yes',
        defaultMessage: 'Yes'
    },
    fnolNo: {
        id: 'portal.fnol.common.controllers.MoreInfoCtrl.No',
        defaultMessage: 'No'
    },
    otherPerson: {
        id: 'portal.fnol.common.controllers.MainContactCtrl.Other Person',
        defaultMessage: 'Other Person'
    },
    newContact: {
        id: 'portal.fnol.common.controllers.MainContactCtrl.New Contact',
        defaultMessage: 'New Contact'
    },
    fnolDetailedPolicyNumber: {
        id: 'portal.fnol.common.directives.policy-search-result-detailed.Policy Number',
        defaultMessage: 'Policy Number'
    },
    fnolDetailedInsured: {
        id: 'portal.fnol.common.directives.policy-search-result-detailed.Insured',
        defaultMessage: 'Insured'
    },
    fnolDetailedAddress: {
        id: 'portal.fnol.common.directives.policy-search-result-detailed.Address',
        defaultMessage: 'Address'
    },
    fnolDetailedType: {
        id: 'portal.fnol.common.directives.policy-search-result-detailed.Type',
        defaultMessage: 'Type'
    },
    fnolDetailedEffective: {
        id: 'portal.fnol.common.directives.policy-search-result-detailed.Effective',
        defaultMessage: 'Effective'
    },
    fnolDetailedExpires: {
        id: 'portal.fnol.common.directives.policy-search-result-detailed.Expires',
        defaultMessage: 'Expires'
    },
    successfullySubmitted: {
        id: 'portal.fnol.common.views.confirmation.Claim was successfully submitted',
        defaultMessage: 'Claim was successfully submitted'
    },
    confirmationThankMessage: {
        id: 'portal.fnol.common.views.confirmation.Thank you for submitting a claim. Our Adjustment team will be in contact shortly.',
        defaultMessage: 'Thank you for submitting a claim. Our Adjustment team will be in contact shortly.'
    },
    referenceNumber: {
        id: 'portal.fnol.common.views.confirmation.Claim Reference number',
        defaultMessage: 'Claim reference number { num }'
    },
    foundationInsurance: {
        id: 'portal.fnol.common.views.confirmation.Kind regards, Foundation Insurance',
        defaultMessage: 'Kind regards, Foundation Insurance'
    },
    printConfirmation: {
        id: 'portal.fnol.common.views.confirmation.Print Confirmation',
        defaultMessage: 'Print Confirmation'
    },
    fnolSaveandExit: {
        id: 'portal.fnol.wizard.Cancel',
        defaultMessage: 'Cancel'
    },
    fnolSubmitClaim: {
        id: 'portal.fnol.common.views.summary.Submit My Claim Now',
        defaultMessage: 'Submit Claim'
    },
    fnolSubmitClaimShort: {
        id: 'portal.fnol.common.views.summary.Submit',
        defaultMessage: 'Submit'
    },
    fnolNoteErrorHead: {
        id: 'portal.fnol.common.controllers.SummaryCtrl.Note Error Head',
        defaultMessage: 'Note submission failed'
    },
    fnolNoteErrorMessage: {
        id: 'portal.fnol.common.controllers.SummaryCtrl.Note Error Message',
        defaultMessage: 'Note cannot be processed at this time. '
    },
    fnolSubmitClaimDetails: {
        id: 'portal.fnol.common.config.FlowConfig.Submitting claim details...',
        defaultMessage: 'Submitting claim details...'
    },
    fnolErrorSubmitClaimTitle: {
        id: 'portal.fnol.common.config.FlowConfig.Error submitting claim',
        defaultMessage: 'Error submitting claim'
    },
    fnolErrorSubmitClaimMessage: {
        id: 'portal.fnol.common.config.FlowConfig.An error occurred attempting to submit the claim.',
        defaultMessage: 'An error occurred attempting to submit the claim.'
    },
    fnolSaveDraftErrorTitle: {
        id: 'portal.fnol.common.config.FlowConfig.Unable to save draft claim information',
        defaultMessage: 'Unable to save draft claim information'
    },
    fnolSaveDraftErrorMessage: {
        id: 'portal.fnol.common.config.FlowConfig.An error occurred while attempting to save the claim submission.',
        defaultMessage: 'We are currently unable to access your data. Please contact us at 1-800-231-1363 so that we can assist.'
    },
    fnolSaveDraftClaim: {
        id: 'portal.fnol.common.config.FlowConfig.Saving draft claim details...',
        defaultMessage: 'Saving draft claim details...'
    },
    generalCreateDraftErrorTitle: {
        id: 'portal.fnol.general.config.FlowConfig.Error creating claim',
        defaultMessage: 'Error creating claim'
    },
    generalCreateDraftErrorMessage: {
        id: 'portal.fnol.general.config.FlowConfig.An error occurred attempting to create a claim.',
        defaultMessage: 'An error occurred attempting to create a claim.'
    },
    generalCreateDraftClaim: {
        id: 'portal.fnol.general.config.FlowConfig.Creating draft claim...',
        defaultMessage: 'Creating draft claim...'
    },
    wizardTypeOfIncident: {
        id: 'portal.fnol.wizard.step.general.Type of Incident',
        defaultMessage: 'Type of Incident'
    },
    generalWizardTypeOfIncident: {
        id: 'portal.fnol.wizard.step.general.Type of Incident',
        defaultMessage: 'Type of Incident'
    },
    wizardTitleWhere: {
        id: 'portal.fnol.wizard.step.general.Where',
        defaultMessage: 'Where'
    },
    generalWasAnyoneInjured: {
        id: 'portal.fnol.general.views.what.Was anyone injured?',
        defaultMessage: 'Was anyone injured?'
    },
    generalAddAnInjured: {
        id: 'portal.fnol.general.views.what.Add an injured...',
        defaultMessage: 'Add an injured...'
    },
    generalFirstName: {
        id: 'portal.fnol.general.views.what.First Name',
        defaultMessage: 'First Name'
    },
    generalLastName: {
        id: 'portal.fnol.general.views.what.Last Name',
        defaultMessage: 'Last Name'
    },
    generalFirstNameKanji: {
        id: 'portal.fnol.general.views.what.First Name Kanji',
        defaultMessage: 'First Name Kanji'
    },
    generalLastNameKanji: {
        id: 'portal.fnol.general.views.what.Last Name Kanji',
        defaultMessage: 'Last Name Kanji'
    },
    generalInjuryDescription: {
        id: 'portal.fnol.general.views.what.Description',
        defaultMessage: 'Description'
    },
    generalInjured: {
        id: 'portal.fnol.general.views.what.Injured',
        defaultMessage: 'Injured #{injuredIndex}'
    },
    generalRemoveInjuredPopupTitle: {
        id: 'portal.fnol.general.views.what.modal.Remove Injured',
        defaultMessage: 'Remove Injured'
    },
    generalRemoveInjuredPopupMessage: {
        id: 'portal.fnol.general.views.what.modal.Are you sure you want to remove Injured #{injuredIndex}?',
        defaultMessage: 'Are you sure you want to remove Injured #{injuredIndex}?',
    },
    generalRemoveInjuredPopupRemoveButton: {
        id: 'portal.fnol.general.views.what.modal.Remove',
        defaultMessage: 'Remove'
    },
    generalDescribeWhatHappened: {
        id: 'portal.fnol.general.views.what.Describe what happened',
        defaultMessage: 'Describe what happened'
    },
    generalLossCause: {
        id: 'portal.fnol.general.views.what.Loss Cause',
        defaultMessage: 'Loss Cause'
    },
    generalSelectLossCause: {
        id: 'portal.fnol.general.views.what.Select Loss Cause',
        defaultMessage: 'Select Loss Cause'
    },
    generalIndicateWhoOrWhat: {
        id: 'portal.fnol.general.views.what.Indicate who or what caused the incident, and provide other details that would be helpful.',
        defaultMessage: 'Indicate who or what caused the incident, and provide other details that would be helpful.'
    },
    generalDescribeDamage: {
        id: 'portal.fnol.general.views.what.Describe damage',
        defaultMessage: 'Describe damage'
    },
    generalListWhatWasDamaged: {
        id: 'portal.fnol.general.views.what.List what was damaged or lost during the incident, such as structural damage or office equipment.',
        defaultMessage: 'List what was damaged or lost during the incident, such as structural damage or office equipment.'
    },
    generalDescribeInjuries: {
        id: 'portal.fnol.general.views.what.Describe injuries if any',
        defaultMessage: 'Describe injuries if any'
    },
    generalTypeOfIncidentDelete: {
        id: 'portal.fnol.wizard.tooltip.Delete',
        defaultMessage: 'Delete'
    },
    cancelModalMessage: {
        id: 'portal.fnol.common.config.FlowConfig.The information you have entered will not be saved.',
        defaultMessage: 'The information you have entered will not be saved.'
    },
    saveAndExitModalTitle: {
        id: 'portal.fnol.common.config.FlowConfig.Want to Leave?',
        defaultMessage: 'Want to Leave?'
    },
    cancel: {
        id: 'portal.fnol.common.config.FlowConfig.Cancel',
        defaultMessage: 'Cancel'
    },
    Ok: {
        id: 'portal.fnol.common.config.FlowConfig.OK',
        defaultMessage: 'OK'
    },
    saveAndExitModalMessage: {
        id: 'fnol.common.config.FlowConfig.Your entries have been saved. A draft claim that starts with "T" will display on your Claims page. A "T" claim is an incomplete submission that has not been submitted for adjudication and will disappear in 7 days if not completed.',
        defaultMessage: 'Your entries have been saved. A draft claim that starts with "T" will display on your Claims page. A "T" claim is an incomplete submission that has not been submitted for adjudication and will disappear in 7 days if not completed.'
    },
    policyChangeModalTitle: {
        id: 'portal.fnol.common.controllers.PolicySelectPolicyholderCtrl.Modal Title',
        defaultMessage: 'Policy change'
    },
    policyChangeModalMessage: {
        id: 'portal.fnol.common.controllers.PolicySelectPolicyholderCtrl.Modal Content',
        defaultMessage: 'You have selected a new policy for this claim. The data you have entered for this claim will be lost.'
    },
    noPolicyFoundMessage: {
        id: 'portal.fnol.common.views.policy-select-policyholder.No policies were found that match the search criteria.',
        defaultMessage: 'No policies were found that match the search criteria.'
    },
    changePolicyButtonlabel: {
        id: 'portal.fnol.common.controllers.PolicySelectPolicyholderCtrl.Modal Option',
        defaultMessage: 'Change Policy'
    },
    fnolMessagePopupYes: {
        id: 'portal.fnol.common.config.FlowConfig.Yes',
        defaultMessage: 'Yes'
    },
    fnolMessagePopupCancel: {
        id: 'portal.fnol.common.config.FlowConfig.Cancel',
        defaultMessage: 'Cancel'
    },
    fnolUnnamed: {
        id: 'portal.fnol.common.model.Unnamed',
        defaultMessage: 'Unnamed'
    },
    fnolBackToHome: {
        id: 'portal.fnol.common.views.confirmation.Back to Homepage',
        defaultMessage: 'Back to Homepage'
    },
    fnolBackToClaims: {
        id: 'portal.fnol.common.views.confirmation.Back to claims',
        defaultMessage: 'Back to claims'
    },
    fnolFelonyText: {
        id: 'portal.fnol.common.views.summary.Any person who makes or causes to be made any knowingly false or fraudulent material statement or material representation for the purpose of obtaining or denying workers’ compensation benefits or payments is guilty of a felony.',
        defaultMessage: ' Any person who makes or causes to be made any knowingly false or fraudulent material statement or material representation for the purpose of obtaining or denying workers’ compensation benefits or payments is guilty of a felony.'
    },
    fnolFelonyTextUT: {
        id: 'portal.fnol.common.views.summary.Any person who knowingly presents false or fraudulent underwriting information, files or causes to be filed a false or fraudulent claim for disability compensation or medical benefits, or submits a false or fraudulent report or billing for health care fees or other professional services is guilty of a crime and may be subject to fines and confinement in state prison.',
        defaultMessage: ' Any person who knowingly  presents false or fraudulent underwriting information, files or causes to be filed a false or fraudulent claim for disability compensation or medical benefits, or submits a false or fraudulent report or billing for health care fees or other professional services is guilty of a crime and may be subject to fines and confinement in state prison.'
    },
    claimStaticText: {
        id: 'portal.fnol.common.views.If a prescription is needed, please provide this information to your ',
        defaultMessage: 'If a prescription is needed, please provide this information to your '
    },
    claimStaticText1: {
        id: 'portal.fnol.common.views.local pharmacy, and have the pharmacy call (800) 563-8438 to ',
        defaultMessage: 'local pharmacy, and have the pharmacy call (800) 563-8438 to '
    },
    claimStaticText2: {
        id: 'portal.fnol.common.views.request activation using this information.',
        defaultMessage: 'request activation using this information. '
    },
    claimStaticText3: {
        id: 'portal.fnol.common.views.BIN # 004336',
        defaultMessage: 'BIN # 004336'
    },
    claimStaticText4: {
        id: 'portal.fnol.common.views.PCN: ADV',
        defaultMessage: 'PCN: ADV'
    },
    claimStaticText5: {
        id: 'portal.fnol.common.views.Group:  RXFFWC9531714',
        defaultMessage: 'Group:  RXFFWC9531714'
    },
    mailingAddress: {
        id: 'portal.fnol.common.views.Mailing address for medical bills:',
        defaultMessage: 'Mailing address for medical bills:'
    },
    compensationText: {
        id: 'portal.fnol.common.views.Nevada C-4 Form: Employee\'s Claim for Compensation/Report of Initial Treatment',
        defaultMessage: 'Nevada C-4 Form: Employee\'s Claim for Compensation/Report of Initial Treatment'
    },
    faxText: {
        id: 'portal.fnol.common.views.Must be faxed or emailed to:',
        defaultMessage: 'Must be faxed or emailed to:'
    },

    fnolNotSpecifiedStatesText: {
        id: 'portal.fnol.common.views.summary. Any person who makes or causes to be made any knowingly false or fraudulent material statement or material representation for the purpose of obtaining or denying workers’ compensation benefits or payments is guilty of a felony.',
        defaultMessage: '  Any person who makes or causes to be made any knowingly false or fraudulent material statement or material representation for the purpose of obtaining or denying workers’ compensation benefits or payments is guilty of a felony.'
    },
    fnolArkansaText: {
        id: 'portal.fnol.common.views.summary. Any person or entity who willfully and knowingly makes any material false statement or representation, who willfully and knowingly omits or conceals any material information, or who willfully and knowingly employs any device, scheme or artifice, for the purpose of: (i) obtaining any benefit or payment; (ii) defeating or wrongfully increasing or wrongfully decreasing any claim for benefit or payment; or (iii) obtaining or avoiding workers compensation coverage or avoiding payment of the proper insurance premium, or who aids and abets for any of said purposes, under this chapter will be guilty of a Class D felony. Fifty percent (50%) of any criminal fine imposed and collected under this subdivision (a)(1) or subdivision (a)(2) of this section shall be paid and allocated in accordance with applicable law to the Death and Permanent Total Disability Trust Fund administered by the Workers’ Compensation Commission.',
        defaultMessage: '  Any person or entity who willfully and knowingly makes any material false statement or representation, who willfully and knowingly omits or conceals any material information, or who willfully and knowingly employs any device, scheme or artifice, for the purpose of: (i) obtaining any benefit or payment; (ii) defeating or wrongfully increasing or wrongfully decreasing any claim for benefit or payment; or (iii) obtaining or avoiding workers compensation coverage or avoiding payment of the proper insurance premium, or who aids and abets for any of said purposes, under this chapter will be guilty of a Class D felony. Fifty percent (50%) of any criminal fine imposed and collected under this subdivision (a)(1) or subdivision (a)(2) of this section shall be paid and allocated in accordance with applicable law to the Death and Permanent Total Disability Trust Fund administered by the Workers’ Compensation Commission.'
    },
    fnolColumbiaText: {
        id: 'portal.fnol.common.views.summary. Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison.',
        defaultMessage: '  Any person who knowingly presents a false or fraudulent claim for payment of a loss or benefit or knowingly presents false information in an application for insurance is guilty of a crime and may be subject to fines and confinement in prison.'
    },
    fnolFloridaText: {
        id: 'portal.fnol.common.views.summary.An injured employee or any other party making a claim under this chapter must provide his or her personal signature attesting that he or she has reviewed, understands, and acknowledges the following statement: “Any person who, knowingly and with intent to injure, defraud, or deceive any employer or employee, insurance company, or self-insured program, files a statement of claim containing any false or misleading information, commits insurance fraud, punishable as provided in s. 817.234.” An injured party’s refusal to sign the document attesting review, understanding, and acknowledgement of the statement will result in the suspension of workers compensation benefits or payments until such signature is obtained.',
        defaultMessage: '  An injured employee or any other party making a claim under this chapter must provide his or her personal signature attesting that he or she has reviewed, understands, and acknowledges the following statement: “Any person who, knowingly and with intent to injure, defraud, or deceive any employer or employee, insurance company, or self-insured program, files a statement of claim containing any false or misleading information, commits insurance fraud, punishable as provided in s. 817.234.” An injured party’s refusal to sign the document attesting review, understanding, and acknowledgement of the statement will result in the suspension of workers compensation benefits or payments until such signature is obtained.'
    },
    fnolMinnesotaText: {
        id: 'portal.fnol.common.views.summary. Any person who, with intent to defraud, receives workers’ compensation benefits to which the person is not entitled by knowingly misrepresenting, misstating, or failing to disclose any material fact is guilty of theft and shall be sentenced pursuant to s 609.52, subdivision 3.',
        defaultMessage: '  Any person who, with intent to defraud, receives workers’ compensation benefits to which the person is not entitled by knowingly misrepresenting, misstating, or failing to disclose any material fact is guilty of theft and shall be sentenced pursuant to s 609.52, subdivision 3.'
    },
    fnolHampshireText: {
        id: 'portal.fnol.common.views.summary.  Any person who, with a purpose to injure, defraud or deceive any insurance company, files a statement of claim containing any false, incomplete or misleading information is subject to prosecution and punishment for insurance fraud as provided in RSA 638:20.',
        defaultMessage: '   Any person who, with a purpose to injure, defraud or deceive any insurance company, files a statement of claim containing any false, incomplete or misleading information is subject to prosecution and punishment for insurance fraud as provided in RSA 638:20.'
    },
    fnolNewJerseyText: {
        id: 'portal.fnol.common.views.summary. Any person who includes any false or misleading information on an application for an insurance policy is subject to criminal and civil penalties.',
        defaultMessage: '  Any person who includes any false or misleading information on an application for an insurance policy is subject to criminal and civil penalties.'
    },
    fnolOklahomaText: {
        id: 'portal.fnol.common.views.summary.  Any person or entity who makes any material false statement or representation, who willfully and knowingly omits or conceals any material information, or who employs any device, scheme, or artifice, or who aids and abets any person for the purpose of: 1. Obtaining any benefit or payment, 2. increasing any claim for benefit or payment, or 3. obtaining workers’ compensation coverage under this act, shall be guilty of a felony punishable pursuant of Section 1663 of Title 21 of the Oklahoma Statutes.',
        defaultMessage: '   Any person or entity who makes any material false statement or representation, who willfully and knowingly omits or conceals any material information, or who employs any device, scheme, or artifice, or who aids and abets any person for the purpose of: 1. Obtaining any benefit or payment, 2. increasing any claim for benefit or payment, or 3. obtaining workers’ compensation coverage under this act, shall be guilty of a felony punishable pursuant of Section 1663 of Title 21 of the Oklahoma Statutes.'
    },
    fnolPennsylvaniaText: {
        id: 'portal.fnol.common.views.summary. Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties.',
        defaultMessage: '  Any person who knowingly and with intent to defraud any insurance company or other person files an application for insurance or statement of claim containing any materially false information or conceals for the purpose of misleading, information concerning any fact material thereto commits a fraudulent insurance act, which is a crime and subjects such person to criminal and civil penalties.'
    },
    fnolUTText: {
        id: 'portal.fnol.common.views.summary. Any person who knowingly presents false or fraudulent underwriting information, files or causes to be filed a false or fraudulent claim for disability compensation or medical benefits, or submits a false or fraudulent report or billing for health care fees or other professional services is guilty of a crime and may be subject to fines and confinement in state prison.',
        defaultMessage: '  Any person who knowingly presents false or fraudulent underwriting information, files or causes to be filed a false or fraudulent claim for disability compensation or medical benefits, or submits a false or fraudulent report or billing for health care fees or other professional services is guilty of a crime and may be subject to fines and confinement in state prison.'
    },
    fnolInAllOtherStateText: {
        id: 'portal.fnol.common.views.summary.  Any person who makes or causes to be made any knowingly false or fraudulent material statement or material representation for the purpose of obtaining or denying workers’ compensation benefits or payments is guilty of a felony.',
        defaultMessage: '   Any person who makes or causes to be made any knowingly false or fraudulent material statement or material representation for the purpose of obtaining or denying workers’ compensation benefits or payments is guilty of a felony.'
    },
});